<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Exam Live Dashboard</span>
        </v-row>
        <br />
                      <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="card">
            <v-card-title class="heading">Exam Live Dashboard</v-card-title>
            <v-dialog v-model="dialog_ab_stud" scrollable max-width="1000px">
                    <v-card>
                        <center class="heading"><strong>Absent Student Details</strong></center>
                        <v-card>
                        <v-col cols="12" sm="12" md="12">
                            <download-excel :data="absent_learner_data_details" worksheet="absent_learner_data_details" :fields="exam_absent_list" name="Absent_Student_list.xls">
                            <v-btn color="success" class="ma-2 white--text downbtn">
                                <v-icon left dark>mdi-file-excel</v-icon>
                                export xls
                            </v-btn>
                        </download-excel>
                         <v-data-table :headers="headers_abb" :items="absent_learner_data_details"  sort-by class="elevation-1 mytable" :search="search" >
                         </v-data-table>
                        </v-col>
                        <v-card-actions class="justify-center">
                            <v-btn class="button" text @click="dialog_ab_stud = false">Close</v-btn>
                        </v-card-actions>
                         </v-card>
                    </v-card>
                </v-dialog>
            <template>
                <v-data-table :search="search1" :headers="newHeaders" :items="examlearnerlist" :expanded.sync="expanded" :single-expand="singleExpand" item-key="srno" show-expand class="elevation-1 table-data">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-text-field v-model="search1" label="Search" class="pt-4"></v-text-field>
                            <v-spacer></v-spacer>

                            <div style="text-align: center;">
                                <div>
                                    <span class="refresh">Refresh Live data</span>
                                </div>
                                <div>
                                    <v-icon style="font-size: 35px; color: #5cbbf6;" @click="refreshTable">mdi-refresh-circle</v-icon>
                                </div>
                            </div>
                            <!-- <v-icon style="font-size:35px; color: #5cbbf6;" @click="refreshTable">mdi-refresh-circle</v-icon> -->
                            <!-- <v-btn @click="refreshTable" class="button">Refresh</v-btn> -->
                            <v-spacer></v-spacer>
                            <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch>
                        </v-toolbar>
                    </template>

                    <template v-slot:item.log="{ item }">
                        <i class="mdi mdi-eye eye" style="text-align: center; color: #5cbbf6;" @click="viewAllPhoto(item)"></i>
                    </template>
                                  
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" style="padding-left: 30px;">

 <v-simple-table >
        <!-- <caption class="headline">Roles of {{seluser.username}}</caption> -->
      
      <thead>
        <tr>
          <th class="text-left">Marks</th>
          <th class="text-left">Exam Status</th>
          <th class="text-left">Delete LES</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in item.data" :key="item.id">
          <td>{{ item.marks }}</td>
           <td>{{ item.exam_status }}</td>
           <td>
               <div>
              <v-avatar style="" size="25" class="delete-avatar">
               <v-icon class="mr-2 delete-v-icon" style="color:red" :disabled="deleteFlag"  @click="deleteLES(item.id)" title="Delete LES">delete</v-icon> 
              </v-avatar>
              </div>
           </td>
        </tr>
      </tbody>
  </v-simple-table> 
                        </td>
                    </template>
                </v-data-table>
                 
            </template>
        </v-card>
        <div class="text-center" v-if="loading4">
            <v-progress-circular v-model="loading4" :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            dialog_zooimg: false,
            img_url: "",
            deleteFlag:false,
            allPhoto: null,
            photoPath: [],
            overlay:false,
            dialog_allPhoto: false,
            loading4: false,
            details_id: "",
            start_date: "",
            starttime: "",
            endtime: "",
            extratime: null,
            examstatuslist: "",
            extra: "",
            status: "",
            logs: "",
            procstatus: "",
            remtime: "",
            Update: "",
            updatetoalltime: "",
            updatetoallstatus: "",
            exam_id: "",
            examstatus: "",
            expanded: [],
            singleExpand: false,
            search1: "",
            dialog_ab_stud: false,
            newHeaders1:[
                { text: "SrNo", value: "srno" },
                { text: "Student Name", value: "grno" },
                { text: "Start Time", value: "started_at" },
                { text: "End Time", value: "end_time" },
                { text: "Student End Time", value: "exam_end_time" },
                { text: "Proctor Name", value: "proctor_name" },
                { text: "Ip Address", value: "ipaddress" },
                { text: "Remaining Time(minutes)", value: "remaining_time" },
                { text: "View Proctoring Logs", value: "log" },
                { text: "", value: "" },
            ],
            newHeaders: [
                { text: "Student Name", value: "grno" },
            ],
            exam_list: "",
            exam_deatils: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            exam_summary_list: "",
            examlearnerlist: [],
            search: "",
            proctorloglist: "",
            student:null,
            //vrushali
            course_off_learner: "",
            all_learner_data: "",
            absent_learner_data: "",
            absent_learner_data_details: "",
            geolocation_config: false,
        }),
        mounted() {
            this.proceed();
        },
        methods: {
           
            refreshTable() {
                //alert("Reload Table")
                this.proceed();
            },

            proceed() {
                if (this.$store.getters.exam_id == null) {
                    // alert('exam_id id not passed')
                    this.$router.push({ name: "coe-live-dashbord" });
                }
                const formData = {
                    examtt: this.$store.getters.exam_id,
                    // program_id: this.$store.getters.program_id,
                    // program_type_id: this.$store.getters.program_type_id,
                    // year_id: this.$store.getters.year_id,
                };
                (this.overlay = true),
                    axios
                        .post("ExamLiveDashbord/getlearnerExamDetailsDuplicateLES", formData)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                if(res.data.geolocation_config == "YES")
                                {
                                    this.geolocation_config = true
                                }
                                else{
                                    this.geolocation_config = false
                                }
                                this.examlearnerlist = res.data.Exam_Details_List;
                                // this.start_date = res.data.examdate;
                                // this.starttime = res.data.examstarttime;
                                // this.endtime = res.data.examendtime;
                                // this.examstatuslist = res.data.examststatuslist;
                                // this.examstatuslist1 = res.data.examststatuslist;
                                // this.procstatus = res.data.procststatuslist;
                                // this.remtime = res.data.remtime;
                                // this.exam_id = res.data.exam;
                                this.overlay = false;

                                //vrushali code
                                // this.course_off_learner = res.data.course_off_learner;
                                // this.all_learner_data = res.data.all_learner_data.length;
                                // this.absent_learner_data = res.data.course_off_learner - res.data.all_learner_data.length;
                                // this.absent_learner_data_details = res.data.absent_learner_data;
                                //console.log(this.absent_learner_data)
                            } else {
                                this.overlay = false;
                                this.showSnackbar("#b71c1c", "Exam Has Not Started Yet....");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.overlay = false;
                        })
                        .finally(() => {
                            var overlay = false;
                        });
            },


            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

deleteLES(lesId) {
                this.overlay = true;
                this.deleteFlag = true
                    const formData = {
                        lesId: lesId,
                    };
                    axios
                        .post("ExamLiveDashbord/deleteLES", formData)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.overlay = false;
                                this.proceed();
                                this.showSnackbar("#4caf50", "LES deleted Successfully....");
                                this.deleteFlag = false
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.overlay = false;
                            this.deleteFlag = false
                        });
            },
        },
    };
</script>
<style scoped>
    .refresh {
        font-size: 11px;
        color: green;
    }
    .ex-text {
        font-weight: 500;
        margin-bottom: 0px;
    }
    .elevation-1 /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
    }
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    .label {
        font-weight: bold;
        color: hsla(190, 99%, 30%, 1);
        font-size: 15px;
    }
    .box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
        border-radius: 7px;
    }
    .value {
        font-size: 17px;
    }
    .inner-box {
        padding-top: 1rem;
        border: 2px solid hsla(190, 99%, 30%, 1);
        margin: 6px;
        border-radius: 7px;
    }
    .v-data-table tbody tr td {
        border: none !important;
    }
    .table-data {
        margin: 8px;
    }
    .time >>> .v-input__slot {
        width: 10rem;
    }
    .abstud {
        text-decoration: underline;
    }
    .textcolor {
        color: orange;
    }
    .eye {
        font-size: 30px;
        cursor: pointer;
    }
    .card {
        border: 1px solid hsla(190, 99%, 30%, 1) !important;
    }
    .theme--light.v-data-table thead tr th {
        color: white;
        background-color: hsla(190, 99%, 30%, 1) !important;
        font-weight: bold;
    }
    .all-pic {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white;
    }
    .time-btn {
        height: 2rem;
        background-color: red;
        padding: 2px;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .v-progress-circular {
        margin: 1rem;
    }
     /* .mytable /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        white-space: nowrap !important;
    } */
</style>
